import React from 'react'
import {
  Button,
  Input,
  SearchField as AriaSearchField,
  SearchFieldProps as AriaSearchFieldProps,
} from 'react-aria-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'

import './SearchField.css'

export interface SearchFieldProps extends AriaSearchFieldProps {
  label?: string
  placeholder?: string
}

export function SearchField({ label = 'Search', ...props }: SearchFieldProps) {
  return (
    <AriaSearchField {...props} aria-label={label}>
      <FontAwesomeIcon icon={faSearch} />
      <Input />
      <Button>✕</Button>
    </AriaSearchField>
  )
}
